/** Load one Overview resource without treating an HTTP failure as empty data. */
export async function overviewRequest(url: string, label: string) {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(response.status === 403
      ? `Access denied to ${label}.`
      : `${label} unavailable. Please try again.`);
  }
  return response.json();
}
